import React from "react";
import withStyles from '@mui/styles/withStyles';

const styles = (theme) => ({
  root: {
    backgroundColor: "#fff",
  },
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing ? theme.spacing(2) : "16px",
    flex: 1,
  },
  toolbar: {
    backgroundColor: "#fff",
  },
  custom: {
    padding: theme.spacing ? theme.spacing(2) : "16px",
    paddingBottom: theme.spacing ? theme.spacing(8) : "64px",
  },
  iframeholder: {
    width: "100vw",
    height: "100vh",
    "-webkit-overflow-scrolling": "touch",
    overflowY: "scroll",
  },
  iframe: {
    width: 1,
    minWidth: "100%",
    height: "100vh",
    border: 0,
  },
  iframeBar: {
    position: "absolute",
    height: 60,
    width: "100%",
    backgroundColor: "#1AB2B3",
    color: "#fff",
    paddingLeft: 20,
  },
});

function KyteTecForm({ classes, couponCode, discount, oneKeyId}) {

  const iFrameUrl = `https://cb.kyte-tec.com/app/form?id=DF8Fsg&b=0/?onekey=${oneKeyId}&ucc=${couponCode}1&wert=${discount}`;

  return (
    <>
      <div className={classes.root}>
        <iframe
          id="kyte-tec-frame"
          allowtransparency="true"
          style={{ width: "100vw", height: "80vh", border: 0 }}
          src={iFrameUrl}
          title="Kyte Tec Form"
        ></iframe>
      </div>
    </>
  );
}

export default withStyles(styles)(KyteTecForm);
